import React from 'react';
import { PropTypes } from 'prop-types';
import reactStringReplace from 'react-string-replace';

import { useGetGoodyBagOwnerQuery } from 'app/api/mainApi';

import PaymentButtonPreview from './PaymentButtonPreview';
import GoodyBagButtonPreview from './GoodyBagButtonPreview';

const decoratedContent = (postBody, currentUserId, isOwner) => {
  const urlBase = document.location.href.match(/\bhttps?:\/\/[^\/]+/i)[0];
  const localUrlRegex = new RegExp(`${urlBase}\\/\\S*`, 'gi');
  const blogUrlRegex = /https:\/\/phonesexblog.niteflirt.com\//gi;

  const paymentButtonRegex = /\/messages\/click_payment_button\?id=\d+/gi;
  const goodyBagRegex = /\/goodies\/click\/(\d+)-(\d+)/i;

  return reactStringReplace(
    postBody,
    new RegExp(`(${localUrlRegex.source}|${blogUrlRegex.source})`, 'gi'),
    (url, i) => {
      if (url.match(paymentButtonRegex)) {
        return <PaymentButtonPreview url={url} loggedIn={!!currentUserId} isOwner={isOwner} key={`pb${i}`} />;
      } else if (url.match(goodyBagRegex)) {
        const matchData = url.match(goodyBagRegex);
        const advisorId = matchData[1];
        // NOTE: The second match is the goodybag id, that we won't need to use here.
        // const goodyBagId = matchData[2];

        // The show action takes the login name instead of the ID, so we are forced to use this index API instead.
        const { data: owner } = useGetGoodyBagOwnerQuery({ advisorId });

        return <GoodyBagButtonPreview url={url} currentUserId={currentUserId} sender={owner?.login || ''} key={`gb${i}`} />;
      } else {
        return <a href={url} target="_blank" key={`url${i}`} rel="noreferrer">{url}</a>;
      }
    },
  );
};

const PostBody = ({ post, currentUserId }) => {
  const isOwner = post.main_user_id === currentUserId;
  return (
    <div className="blockOfText">
      { post.body && decoratedContent(post.body, currentUserId, isOwner) }
      { post.body && post.paid_body && <hr /> }
      { post.paid_body && decoratedContent(post.paid_body, currentUserId, isOwner) }
    </div>
  );
};

PostBody.propTypes = {
  post: PropTypes.object.isRequired,
  currentUserId: PropTypes.number,
};

PostBody.defaultProps = {
  currentUserId: null,
};

export default PostBody;
